import trTR from "antd/locale/tr_TR";
import enUS from "antd/locale/en_US";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import { sporAntdTheme } from "../theme/sporBrand";

const getSporLocale = (lng, t) => {
  const base = lng === "en" ? enUS : trTR;
  return {
    ...base,
    Table: {
      ...base.Table,
      emptyText: t("common.noRecords"),
    },
  };
};

export const AntdConfigProvider = ({ children }) => {
  const { i18n, t } = useTranslation();

  return (
    <ConfigProvider
      componentSize={window.innerWidth < 768 ? "small" : "middle"}
      locale={getSporLocale(i18n.language, t)}
      theme={sporAntdTheme}
    >
      {children}
    </ConfigProvider>
  );
};
